import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { SimpleAutocomplete } from '~/modules/common/components/SearchAutocomplete';
import FacetDetailField from '../../FacetDetailField';
import UserItem from '../components/UserACItem';
import { onChange } from '../enhancers/facetHelpers';
import { useClientManagers } from './enhancers/useClientManagers';

const renderOption = option => <UserItem option={option} />;

export const clientManagerLabel = (
  <FormattedMessage id="search.clientManager" />
);

export const ClientManagerFacetDetails = ({
  className,
  selected,
  setSelected
}) => {
  const { formatMessage } = useIntl();
  const getOptionDisabled = useCallback(
    option => selected.some(v => v.id === option.id),
    [selected]
  );

  const onValueChange = useCallback(
    selectedOptions => onChange({ selectedOptions, setSelected }),
    [setSelected]
  );

  const { clientManagers, loading } = useClientManagers();

  const options = (!loading && clientManagers) || [];

  return (
    <FacetDetailField label={clientManagerLabel} className={className}>
      <SimpleAutocomplete
        options={options}
        variant="standard"
        loading={loading}
        inputLabel={formatMessage({ id: 'search.clientManager' })}
        getOptionDisabled={getOptionDisabled}
        hiddenLabel
        noOptionsText={formatMessage({ id: 'client.noClientManager' })}
        onChange={onValueChange}
        fullWidth
        value={selected}
        optionPropText="label"
        multiple
        renderOption={renderOption}
      />
    </FacetDetailField>
  );
};

ClientManagerFacetDetails.propTypes = {
  className: PropTypes.string,
  selected: PropTypes.array.isRequired,
  setSelected: PropTypes.func.isRequired
};

export default ClientManagerFacetDetails;
